import React from "react";
import styles from "./button.module.scss";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'primary' | 'secondary' | 'ghost' | 'link' | 'outline';
  size?: 'small' | 'default';
  disabled?: boolean;
  fullWidth?: boolean;
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({
	children,
	onClick,
	type = "button",
	variant = "primary",
	size = "default",
	disabled = false,
	fullWidth = false,
	className = "",
	...props
}) => {
	return (
		<button
			type={type}
			onClick={onClick}
			disabled={disabled}
			className={`${styles.button} ${styles[size]} ${styles[variant]} ${fullWidth ? styles.fullWidth : ""} ${className}`}
			{...props}
		>
			{children}
		</button>
	);
};
